module.exports = __webpack_public_path__ + "img/ez-slot-ic_login.73d6eb5a.png";